import { Component, Input, ElementRef } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Component({
  selector: "uex-image",
  templateUrl: "./image.component.html",
  host: {
    class: "uex-image",
    "[style.background-image]": "formatted_src",
    "[style.width]": "width",
    "[style.height]": "height"
  }
})
export class ImageComponent {
  @Input("src") private set _src(newValue: string) {
    this.src = newValue
      ? this._domSanitizer.bypassSecurityTrustResourceUrl(newValue)
      : null;
    this.formatted_src = this.src ? `url(${newValue})` : null;
  }
  @Input("width") private set _width(newValue: number | string) {
    this.width = this._checkUnit(newValue);
  }
  @Input("height") private set _height(newValue: number | string) {
    this.height = this._checkUnit(newValue);
  }
  @Input("size") private set size(newValue: number | string) {
    this.width = this._checkUnit(newValue);
    this.height = this._checkUnit(newValue);
  }

  constructor(
    private _domSanitizer: DomSanitizer,
    public elementRef: ElementRef
  ) {}

  public src: SafeUrl = null;
  public formatted_src: string = null;
  public width: string = null;
  public height: string = null;

  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }

  private _checkUnit(value: number | string): string {
    if (typeof value === "number") {
      return `${value}px`;
    }

    const hasPx = value.indexOf("px") >= 0;
    const hasRem = value.indexOf("rem") >= 0;
    const hasPercent = value.indexOf("%") >= 0;

    if (hasPx || hasRem || hasPercent) return value;

    return `${value}px`;
  }
}
